import { useContext } from "react";

import {
  SystemMessageContext,
  PushMessageOption,
} from "@/components/contexts/SystemMessageContext";

export function useSystemMessage() {
  const { push } = useContext(SystemMessageContext);

  return {
    info(text: string, option?: PushMessageOption) {
      push({ type: "info", text }, option);
    },
    success(text: string, option?: PushMessageOption) {
      push({ type: "success", text }, option);
    },
    warn(text: string, option?: PushMessageOption) {
      push({ type: "warn", text }, option);
    },
    danger(text: string, option?: PushMessageOption) {
      push({ type: "danger", text }, option);
    },
  };
}
